export default __webpack_public_path__ + "static/media/6_Small_Blue_Egg.15691179.png";